import { BaseFetch } from "../main-model"
export default class AnalysisModel extends BaseFetch {
  getAnalysisBy = (data) =>
    this.authFetch({
      url: "analysis/getAnalysisBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getAnalysisById = (data) =>
    this.authFetch({
      url: "analysis/getAnalysisById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAnalysisById = (data) =>
    this.authFetch({
      url: "analysis/updateAnalysisById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAnalysis = (data) =>
    this.authFetch({
      url: "analysis/insertAnalysis",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAnalysisById = (data) =>
    this.authFetch({
      url: "analysis/deleteAnalysisById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
